'use client';
import { __rest } from 'tslib';
import React, { forwardRef } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { CheckIcon } from '@radix-ui/react-icons';
import { styled } from '../../../stitches.config.js';
import { selectColorVariants } from '../styles.js';

const selectItemStyle = {
    all: 'unset',
    display: 'flex',
    alignItems: 'center',
    color: '$primary12',
    padding: '0 35px 0 25px',
    position: 'relative',
    userSelect: 'none',
    borderRadius: 3,
    height: 25,
    fontSize: 13,
    lineHeight: 1,
    '&[data-disabled]': {
        color: '$gray8',
        pointerEvents: 'none',
    },
    "&:hover": {
        backgroundColor: '$gray5',
        color: '$primary12',
    },
    '&[data-highlighted]': {
        backgroundColor: '$gray5',
        color: '$primary12',
    },
    variants: Object.assign({}, selectColorVariants)
};
const SelectItem = styled(SelectPrimitive.Item, Object.assign({}, selectItemStyle));
styled('div', {
    position: 'absolute',
    left: 0,
    width: 25,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
});
const SelectItemButton = styled('button', Object.assign(Object.assign({}, selectItemStyle), { width: 'stretch' }));
const Indicator = styled(SelectPrimitive.ItemIndicator, {
    position: 'absolute',
    left: 0,
    width: 25,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
});
const Item = forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(SelectItem, Object.assign({}, props, { ref: forwardedRef }),
        React.createElement(SelectPrimitive.ItemText, null, children),
        React.createElement(Indicator, null,
            React.createElement(CheckIcon, null))));
});
Item.displayName = 'Item';
const ItemButton = (({ children, handleClick }) => {
    return (React.createElement(SelectItemButton, { onClick: handleClick },
        React.createElement(SelectPrimitive.ItemText, null, children),
        React.createElement(Indicator, null,
            React.createElement(CheckIcon, null))));
});

export { ItemButton, Item as default, selectItemStyle };
